<template>
  <div>
    <v-dialog :value="isActive" persistent max-width="1000" scrollable>
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Detalles
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 90vh; overflow-y: auto;">
            <v-row>
              <!-- Info general del bot -->
              <v-col cols="12" class="pb-0">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      Tiempo de cierre (En segundos)
                    </v-list-item-subtitle>
                    <div>
                      {{ data.closing_time_sg != null ? data.closing_time_sg : "(No posee)" }}
                    </div>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Mensaje inicial</v-list-item-subtitle>
                    <div>{{ data.initial_message }}</div>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Mensaje de despedida</v-list-item-subtitle>
                    <div>{{ data.goodbye_message }}</div>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Mensaje de retorno</v-list-item-subtitle>
                    <div>{{ data.return_message }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <!-- Árbol de Opciones -->
              <v-col cols="12">
                <VTreeCrudList
                  title="Lista de opciones"
                  :data="optionsList"
                  :loadChildren="getChildren"
                  @item:createChild="openCreateNewItem"
                  @item:edit="openEditItem"
                  @item:delete="handleDelete"
                  keyToDisabledAdd="is_sub_menu"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>

        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <new-form-options
      v-if="isOpenFormOptions"
      :isActive="isOpenFormOptions"
      :parentId="selectedItem.id"
      :dataToEdit="selectedOptionToEdit"
      @close:dialog="closeFormDialog"
    ></new-form-options>

    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :dataToEdit="eventToEdit"
      :parentId="selectedItem.id"
      :whatsappId="data.whatsapp_id"
      @close:dialog="closeFormDialog"
    ></newForm>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
import newForm from "./VTreeCrud/newForm.vue";
import NewFormOptions from "./newFormOptions.vue";
import { PbxHttpClient } from "@/services/httpclient";
import VTreeCrudList from "@/components/Utils/VTreeCrud/VTreeCrudDialog.vue";
import { generateTreeData, modifyData } from "@/components/Utils/VTreeCrud/utils";

export default {
  components: {
    vuescroll,
    newForm,
    NewFormOptions,
    VTreeCrudList,
  },
  props: {
    isActive: {
      type: Boolean,
    },
    isOptionEditMode: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isOpenFormOptions: false,
      selectedOptionToEdit: {},
      isOpenForm: false,
      eventToEdit: {},
      selectedItem: {},
      optionsList: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getSelectsInfo();
  },
  methods: {
    // Normalizar opciones para usar texto actual de shared_option si aplica
    formatOption(item) {
      if (!item) return item;
      const isShared = item.shared_option_id != null || !!item.shared_option;
      const displayMessage = isShared && item.shared_option ? item.shared_option.message : item.message;
      return {
        ...item,
        message: displayMessage || item.message,
      };
    },

    openCreateNewItem(item) {
      this.selectedItem = item;

      if (item.nodeType === "submenu") {
        this.isOpenFormOptions = true;
        return;
      }

      if (item.nodeType === "option") {
        this.isOpenForm = true;
        return;
      }
    },

    openEditItem(item) {
      if (item.nodeType === "submenu") {
        this.eventToEdit = item;
        this.isOpenForm = true;
      } else {
        this.selectedOptionToEdit = this.formatOption(item);
        this.isOpenFormOptions = true;
      }
    },

    closeEditDialog(data) {
      const isOption = !!data.bot_id;
      const children = isOption ? this.selectedOptionToEdit.children || [] : this.eventToEdit.children || [];
      const parentId = isOption ? data.bot_id : data.option_id;
      const isMainParent = this.selectedOptionToEdit.isMainParent;

      const formattedData = this.formatOption(data);
      const dataWithChildren = {
        ...formattedData,
        message: formattedData.message || formattedData.menu_message,
        children,
        isMainParent,
      };

      this.optionsList = modifyData([...this.optionsList], dataWithChildren, parentId, isMainParent);
      this.eventToEdit = {};
      this.isOpenForm = false;
      this.selectedOptionToEdit = {};
      this.isOpenFormOptions = false;
    },

    closeFormDialog(data = false, isEdit = false) {
      if (isEdit) {
        this.closeEditDialog(data);
        return;
      }

      if (data) {
        const isOption = !!data.bot_id;
        const parentId = isOption ? data.bot_id : data.option_id;
        const formattedData = this.formatOption(data);
        const dataWithChildren = {
          ...formattedData,
          message: formattedData.message || formattedData.menu_message,
          children: [],
        };

        this.optionsList = modifyData([...this.optionsList], dataWithChildren, parentId);
      }
      this.eventToEdit = {};
      this.isOpenForm = false;
      this.selectedOptionToEdit = {};
      this.isOpenFormOptions = false;

      // Recargar listado para reflejar cambios propagados o conteos
      this.getSelectsInfo();
    },

    async getChildren(item) {
      this.isLoading = true;

      try {
        let data = [];

        if (item.sub_menu) {
          const submenu = item.sub_menu;
          const submenuNode = {
            id: submenu.id,
            message: submenu.menu_message,
            is_sub_menu: true,
            option_id: item.id,
            children: (submenu.options || []).map((opt) => this.formatOption(opt)),
          };
          data = [submenuNode];
        } else {
          if (item.is_sub_menu) {
            data = await this.getOptions(item);
          } else {
            data = await this.getBotFromOption(item);
          }
        }

        if (data && data.length) {
          const itemWithChildren = { ...item, children: data };
          this.optionsList = modifyData([...this.optionsList], itemWithChildren, item.id);
        }
      } catch (error) {
        console.error("Error cargando hijos:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async getOptions(item) {
      try {
        const { data } = await PbxHttpClient.get(`/whatsapps/options_bot/${item.id}`);
        return data.map((el) => ({ ...this.formatOption(el), children: [] }));
      } catch (error) {
        console.error(error);
        this.$snotify.error("Hubo un error al obtener la información.", "Error");
      }
    },

    async getBotFromOption(item) {
      try {
        const { data } = await PbxHttpClient.get(`/whatsapps/bot/${item.id}`);
        return [data];
      } catch (error) {
        console.error(error);
        this.$snotify.error("Hubo un error al obtener la información.", "Error");
      }
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getSelectsInfo() {
      let endpoints = [`/whatsapps/options_bot/${this.data.id}`];
      try {
        const responses = await Promise.all(endpoints.map((endpoint) => PbxHttpClient.get(endpoint)));
        const formattedData = (responses[0].data || []).map((item) => this.formatOption(item));
        this.optionsList = generateTreeData(formattedData);
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
    },

    async handleDelete(event) {
      try {
        const isShared = event.shared_option_id != null;
        const sharedCount = event.shared_by_count || 0;

        let confirmMsg = `¿Está seguro de eliminar la opción "${event.message}"? Ésta acción no es reversible.`;
        if (!isShared && sharedCount > 0) {
          confirmMsg = `Esta opción es original y también se quitará de los ${sharedCount} bots que la usan. ¿Desea continuar?`;
        }

        const confirmRequest = await this.$swalconfirm("Confirmar eliminación", confirmMsg);

        if (confirmRequest.isConfirmed) {
          const { data } = await PbxHttpClient.delete(`/whatsapps/options_bot/${event.id}`);

          if (data && data.removed_shared_option_ids && data.removed_shared_option_ids.length > 0) {
            this.$snotify.info("Se removió la opción de todos los bots vinculados.", "Aviso");
          }

          // Refrescar el árbol completo para limpiar referencias en cascada
          await this.getSelectsInfo();
          this.$snotify.success("Opción eliminada con éxito", "¡Hecho!");
        }
      } catch (error) {
        console.error(error);
        this.$snotify.error("No se pudo eliminar la opción.", "¡Error!");
      }
    },
  },
};
</script>